<template>
	<div>
		<div class="cgqBox">
			<div class="cgqBoxTil">
				{{list.data.menuTitle}}
			</div>
			<div class="cgqBoxCen">
				<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
			</div>
			<div class="cgqBoxSp" :style="{
			paddingRight:bj+'px'
		}">
				<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide" :style="{
			width:`calc(100% )`
		}" v-for="(item,index) in list.data.cover" :key="index">
							<img :src="item" />
							<!-- <video :src="item" :autoplay="true" muted loop></video> -->
						</div>
					</div>
				</div>
				<template v-if="!headerShow">
						<div class="swiper-hexin-prev"  :style="{
							left:`30px`,
							display:qhShow?activeIndex==0?'none':'block':'none'
						}" @click="prev()">
							<img src="@/assets/index/hxz.png" />
						</div>
						<div class="swiper-hexin-next" :style="{
							right:`30px`,
							display:qhShow?activeIndex==list.data.cover.length-1?'none':'block':'none'
						}" @click="next()">
							<img src="@/assets/index/hxy.png" />
						</div>
					</template>
				<!-- <img src="@/assets/product/page6/sp.png" /> -->
				<!-- <video></video> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				bj: '',
				qhShow:true,
				activeIndex: 0,
			}
		},
		mounted() {
			let t = this
			this.getWidth();
			let name = '.swiper-data2-banner' + this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				allowTouchMove: this.list.data.cover.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.$nextTick(function(){
				if(this.list.data.cover.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.cover.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.cover.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.cgqBox {

		padding-bottom: 150px;

		.cgqBoxTil {
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			width: 1200px;
			margin: 0 auto;
			margin-bottom: 40px;
		}

		.cgqBoxCen {
			width: 1200px;
			margin: 0 auto;
			font-size: 18px;
			
			font-weight: 300;
			color: #000000;
			margin-bottom: 40px;
			white-space: pre-line;
		}

		.cgqBoxSp {
			width: 100%;
			height: 600px;
			padding-right: 160px;
			margin-bottom: 38px;
			box-sizing: border-box;

			img {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}

			video {
				width: 100%;
				height: 600px;
			}
		}

		.cgqBoxXiao {
			display: flex;
			overflow-x: auto;

			.cgqBoxFor:not(:last-child) {
				margin-right: 40px;
			}

			.cgqBoxFor {
				width: 300px;

				.cgqBoxForImg {
					width: 70px;
					height: 70px;
					margin-bottom: 40px;

					img {
						width: 70px;
						height: 70px;
						object-fit: cover;
					}
				}

				.cgqBoxForName {
					font-size: 26px;
					
					font-weight: 400;
					color: #000000;
					margin-bottom: 32px;
				}

				.cgqBoxForCen {
					font-size: 18px;
					
					font-weight: 300;
					color: #000000;
				}
			}
		}
	}

	.swiper-data2-banner {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}

	@media screen and (max-width:1200px) {
		.cgqBox {
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;

			.cgqBoxTil {
				font-size: 24px !important;
				margin-bottom: 20px !important;
				width: 100% !important;
			}

			.cgqBoxCen {
				font-size: 14px !important;
				margin-bottom: 20px !important;
				width: 100% !important;
			}

			.swiper-slide {
				width: 100% !important;
			}

			.cgqBoxSp {
				height: auto !important;
				margin-bottom: 20px !important;

				img {
					height: auto !important;
				}

				video {
					height: auto !important;
				}
			}

			.cgqBoxXiao {
				flex-wrap: wrap;

				.cgqBoxFor:not(:last-child) {
					margin-right: 0px !important;
				}

				.cgqBoxFor:nth-of-type(2n-1) {
					margin-right: 20px !important;
				}

				.cgqBoxFor {
					min-width: calc(50% - 10px) !important;

					.cgqBoxForImg {
						width: 40px;
						height: 40px;
						margin-bottom: 20px !important;

						img {
							width: 40px !important;
							height: 40px !important;
							object-fit: cover;
						}
					}

					.cgqBoxForName {
						font-size: 18px !important;
						margin-bottom: 20px !important;
					}

					.cgqBoxForCen {
						font-size: 14px !important;
					}
				}
			}


		}
		.swiper-data2-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
		
	}
</style>